import { Outlet } from 'react-router';

import type { UserPositions } from '@/shared/constants';
import type { TModuleCode } from '@/shared/routes';
import NotFound from '@/shared/widgets/errors/not-found';
import { useAppSelector } from '@/store';

interface IProps {
  /** Модуль, который должен быть открыт сотруднику. */
  module: TModuleCode;
  /** Если задано — экран доступен только этим должностям. */
  positions?: UserPositions[];
}

/**
 * Пускает в раздел, только если он открыт сотруднику (и должность
 * подходит, если экран ограничен должностями). Иначе — 404, как для несуществующего пути.
 */
const ModuleRoute: React.FC<IProps> = ({ module, positions }) => {
  const { modules, employee } = useAppSelector((state) => state.session);

  const hasModule = modules.includes(module);
  const hasPosition =
    !positions ||
    positions.some((position) => position === employee?.position?.code);

  if (!hasModule || !hasPosition) return <NotFound />;

  return <Outlet />;
};

export default ModuleRoute;
